import { v4, v7 } from 'uuid';

/**
 * Generates a version 4 UUID (Universally Unique Identifier).
 *
 * @returns {string} A string representation of the generated UUID.
 *
 * @example
 * const id = uuid();
 * console.log(id); // Output: something like "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed"
 */
export const uuid = (): string => {
    return v4();
};

/**
 * Generates a version 7 UUID (Universally Unique Identifier).
 *
 * @returns {string} A string representation of the generated UUID.
 */
export const uuidV7 = (): string => {
    return v7();
};
